import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deletePoolItem, getPoolPage, updatePoolItem } from "./pool";
import { poolQueryKeys } from "./query-keys";

export function useGetPoolPage(filters, enabled = true) {
  return useQuery({
    queryKey: poolQueryKeys.list(filters),
    queryFn: () => getPoolPage(filters),
    enabled,
    keepPreviousData: true,
  });
}

export function useUpdatePoolItemMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }) => updatePoolItem(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: poolQueryKeys.all });
    },
  });
}

export function useDeletePoolItemMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deletePoolItem(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: poolQueryKeys.all });
    },
  });
}
